<template>
  <el-dialog
    title="选择配件型号"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="toolbar" style="margin-top: -20px">
      <el-button
        type="primary"
        @click="onCreateItem()"
        :disabled="!acList || !acList.length"
      >
        <i class="fas fa-plus"></i> 确定
      </el-button>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      @selection-change="onSelectChanged"
      :row-key="getRowKey"
      ref="tableAccs"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Name" label="配件型号名称" />
      <el-table-column prop="Number" label="配件型号" />
      <el-table-column prop="SNCode" label="配件SN代码" />
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      acList: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.acList = [];
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/model/accessory/list", {
          params: {
            ...this.pager,
            order: ["name", "number", "sn_code"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.acList = [];
      this.$refs.tableAccs.clearSelection();
    },
    onCreateItem() {
      this.$emit("form:saved", this.acList);
      this.onClose();
    },
    onSelectChanged(options) {
      this.acList = options;
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>
